"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * pollination-server
 * Pollination Server OpenAPI Definition
 *
 * The version of the OpenAPI document: 1.1.1
 * Contact: info@pollination.cloud
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobsApi = exports.JobsApiFactory = exports.JobsApiFp = exports.JobsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * JobsApi - axios parameter creator
 * @export
 */
const JobsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a job.
         * @summary Cancel a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJob: (owner, name, jobId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling cancelJob.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling cancelJob.');
            }
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new base_1.RequiredError('jobId', 'Required parameter jobId was null or undefined when calling cancelJob.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs/{job_id}/cancel`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new job.
         * @summary Schedule a job
         * @param {string} owner
         * @param {string} name
         * @param {Job} job
         * @param {string} [authorization]
         * @param {string} [xPollinationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob: (owner, name, job, authorization, xPollinationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling createJob.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling createJob.');
            }
            // verify required parameter 'job' is not null or undefined
            if (job === null || job === undefined) {
                throw new base_1.RequiredError('job', 'Required parameter job was null or undefined when calling createJob.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (xPollinationToken !== undefined && xPollinationToken !== null) {
                localVarHeaderParameter['x-pollination-token'] = String(xPollinationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof job !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(job !== undefined ? job : {}) : (job || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a job.
         * @summary Delete a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob: (owner, name, jobId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling deleteJob.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling deleteJob.');
            }
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new base_1.RequiredError('jobId', 'Required parameter jobId was null or undefined when calling deleteJob.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs/{job_id}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a download link for an artifact in a job folder
         * @summary Download an artifact from the job folder
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {string} [path] The path to an file within a project folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJobArtifact: (owner, name, jobId, path, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling downloadJobArtifact.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling downloadJobArtifact.');
            }
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new base_1.RequiredError('jobId', 'Required parameter jobId was null or undefined when calling downloadJobArtifact.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs/{job_id}/artifacts/download`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a job.
         * @summary Get a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob: (owner, name, jobId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling getJob.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling getJob.');
            }
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new base_1.RequiredError('jobId', 'Required parameter jobId was null or undefined when calling getJob.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs/{job_id}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a list of jobs.
         * @summary List Jobs
         * @param {string} owner
         * @param {string} name
         * @param {Array<string>} [ids]
         * @param {JobStatusEnum} [status]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobs: (owner, name, ids, status, createdAfter, createdBefore, page, perPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling listJobs.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling listJobs.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (createdAfter !== undefined) {
                localVarQueryParameter['created_after'] = (createdAfter instanceof Date) ?
                    createdAfter.toISOString() :
                    createdAfter;
            }
            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = (createdBefore instanceof Date) ?
                    createdBefore.toISOString() :
                    createdBefore;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retry failed runs for a job.
         * @summary Retry failed runs for a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {RetryConfig} retryConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryJob: (owner, name, jobId, retryConfig, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling retryJob.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling retryJob.');
            }
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new base_1.RequiredError('jobId', 'Required parameter jobId was null or undefined when calling retryJob.');
            }
            // verify required parameter 'retryConfig' is not null or undefined
            if (retryConfig === null || retryConfig === undefined) {
                throw new base_1.RequiredError('retryConfig', 'Required parameter retryConfig was null or undefined when calling retryJob.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs/{job_id}/retry`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof retryConfig !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(retryConfig !== undefined ? retryConfig : {}) : (retryConfig || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a list of artifacts in a job folder
         * @summary List files/folders in a job folder
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {Array<string>} [path] The path to an file within a project folder
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchJobFolder: (owner, name, jobId, path, page, perPage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'owner' is not null or undefined
            if (owner === null || owner === undefined) {
                throw new base_1.RequiredError('owner', 'Required parameter owner was null or undefined when calling searchJobFolder.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling searchJobFolder.');
            }
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new base_1.RequiredError('jobId', 'Required parameter jobId was null or undefined when calling searchJobFolder.');
            }
            const localVarPath = `/projects/{owner}/{name}/jobs/{job_id}/artifacts`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (path) {
                localVarQueryParameter['path'] = path;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.JobsApiAxiosParamCreator = JobsApiAxiosParamCreator;
/**
 * JobsApi - functional programming interface
 * @export
 */
const JobsApiFp = function (configuration) {
    return {
        /**
         * Retrieve a job.
         * @summary Cancel a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJob(owner, name, jobId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).cancelJob(owner, name, jobId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Create a new job.
         * @summary Schedule a job
         * @param {string} owner
         * @param {string} name
         * @param {Job} job
         * @param {string} [authorization]
         * @param {string} [xPollinationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob(owner, name, job, authorization, xPollinationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).createJob(owner, name, job, authorization, xPollinationToken, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Delete a job.
         * @summary Delete a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob(owner, name, jobId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).deleteJob(owner, name, jobId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Get a download link for an artifact in a job folder
         * @summary Download an artifact from the job folder
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {string} [path] The path to an file within a project folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJobArtifact(owner, name, jobId, path, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).downloadJobArtifact(owner, name, jobId, path, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retrieve a job.
         * @summary Get a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob(owner, name, jobId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).getJob(owner, name, jobId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retrieve a list of jobs.
         * @summary List Jobs
         * @param {string} owner
         * @param {string} name
         * @param {Array<string>} [ids]
         * @param {JobStatusEnum} [status]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobs(owner, name, ids, status, createdAfter, createdBefore, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).listJobs(owner, name, ids, status, createdAfter, createdBefore, page, perPage, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retry failed runs for a job.
         * @summary Retry failed runs for a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {RetryConfig} retryConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryJob(owner, name, jobId, retryConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).retryJob(owner, name, jobId, retryConfig, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Retrieve a list of artifacts in a job folder
         * @summary List files/folders in a job folder
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {Array<string>} [path] The path to an file within a project folder
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchJobFolder(owner, name, jobId, path, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.JobsApiAxiosParamCreator)(configuration).searchJobFolder(owner, name, jobId, path, page, perPage, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
exports.JobsApiFp = JobsApiFp;
/**
 * JobsApi - factory interface
 * @export
 */
const JobsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Retrieve a job.
         * @summary Cancel a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJob(owner, name, jobId, options) {
            return (0, exports.JobsApiFp)(configuration).cancelJob(owner, name, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new job.
         * @summary Schedule a job
         * @param {string} owner
         * @param {string} name
         * @param {Job} job
         * @param {string} [authorization]
         * @param {string} [xPollinationToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob(owner, name, job, authorization, xPollinationToken, options) {
            return (0, exports.JobsApiFp)(configuration).createJob(owner, name, job, authorization, xPollinationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a job.
         * @summary Delete a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob(owner, name, jobId, options) {
            return (0, exports.JobsApiFp)(configuration).deleteJob(owner, name, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a download link for an artifact in a job folder
         * @summary Download an artifact from the job folder
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {string} [path] The path to an file within a project folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJobArtifact(owner, name, jobId, path, options) {
            return (0, exports.JobsApiFp)(configuration).downloadJobArtifact(owner, name, jobId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a job.
         * @summary Get a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob(owner, name, jobId, options) {
            return (0, exports.JobsApiFp)(configuration).getJob(owner, name, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of jobs.
         * @summary List Jobs
         * @param {string} owner
         * @param {string} name
         * @param {Array<string>} [ids]
         * @param {JobStatusEnum} [status]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobs(owner, name, ids, status, createdAfter, createdBefore, page, perPage, options) {
            return (0, exports.JobsApiFp)(configuration).listJobs(owner, name, ids, status, createdAfter, createdBefore, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry failed runs for a job.
         * @summary Retry failed runs for a Job
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {RetryConfig} retryConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryJob(owner, name, jobId, retryConfig, options) {
            return (0, exports.JobsApiFp)(configuration).retryJob(owner, name, jobId, retryConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of artifacts in a job folder
         * @summary List files/folders in a job folder
         * @param {string} owner
         * @param {string} name
         * @param {string} jobId
         * @param {Array<string>} [path] The path to an file within a project folder
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchJobFolder(owner, name, jobId, path, page, perPage, options) {
            return (0, exports.JobsApiFp)(configuration).searchJobFolder(owner, name, jobId, path, page, perPage, options).then((request) => request(axios, basePath));
        },
    };
};
exports.JobsApiFactory = JobsApiFactory;
/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
class JobsApi extends base_1.BaseAPI {
    /**
     * Retrieve a job.
     * @summary Cancel a Job
     * @param {JobsApiCancelJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    cancelJob(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).cancelJob(requestParameters.owner, requestParameters.name, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new job.
     * @summary Schedule a job
     * @param {JobsApiCreateJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    createJob(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).createJob(requestParameters.owner, requestParameters.name, requestParameters.job, requestParameters.authorization, requestParameters.xPollinationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a job.
     * @summary Delete a Job
     * @param {JobsApiDeleteJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    deleteJob(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).deleteJob(requestParameters.owner, requestParameters.name, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a download link for an artifact in a job folder
     * @summary Download an artifact from the job folder
     * @param {JobsApiDownloadJobArtifactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    downloadJobArtifact(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).downloadJobArtifact(requestParameters.owner, requestParameters.name, requestParameters.jobId, requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a job.
     * @summary Get a Job
     * @param {JobsApiGetJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    getJob(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).getJob(requestParameters.owner, requestParameters.name, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of jobs.
     * @summary List Jobs
     * @param {JobsApiListJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    listJobs(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).listJobs(requestParameters.owner, requestParameters.name, requestParameters.ids, requestParameters.status, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retry failed runs for a job.
     * @summary Retry failed runs for a Job
     * @param {JobsApiRetryJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    retryJob(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).retryJob(requestParameters.owner, requestParameters.name, requestParameters.jobId, requestParameters.retryConfig, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of artifacts in a job folder
     * @summary List files/folders in a job folder
     * @param {JobsApiSearchJobFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    searchJobFolder(requestParameters, options) {
        return (0, exports.JobsApiFp)(this.configuration).searchJobFolder(requestParameters.owner, requestParameters.name, requestParameters.jobId, requestParameters.path, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JobsApi = JobsApi;
